import { Client } from '@/utilities/api/Client';
import { CategoryEndPoint } from '@api/endpoints/CategoryEndPoint';
import { ManufacturerEndpoint } from '@api/endpoints/ManufacturerEndpoint';
import { ProductEndpoint } from '@api/endpoints/ProductEndpoint';
import { QueryUtil } from '../Query';

export class ProductApi {
  static list (): Promise<ProductEndpoint.ProductList.Response> {
    return Client('product/');
  }

  static getCategories (
    query?: CategoryEndPoint.List.Query,
  ): Promise<CategoryEndPoint.List.Response> {
    if (query) {
      return Client(`category?${QueryUtil.stringify(query)}`);
    }
    return Client('category/');
  }

  static getManufacturers (
    query?: ManufacturerEndpoint.List.Query,
  ): Promise<ManufacturerEndpoint.List.Response> {
    if (query) {
      return Client(`manufacturers?${QueryUtil.stringify(query)}`);
    }
    return Client('manufacturers/');
  }

  static create (request: ProductEndpoint.Create.Request):
    Promise<ProductEndpoint.Create.Response> {
    return Client(`product/`, { body: request, method: 'POST' });
  }

  static update (request: ProductEndpoint.Create.Request, id: string):
    Promise<ProductEndpoint.Update.Response> {
    return Client(`product/${id}/`, { body: request, method: 'PATCH' });
  }

  static getPurchaseImpact (
    productId: string,
    query: ProductEndpoint.PurchaseImpact.Query,
  ): Promise<ProductEndpoint.PurchaseImpact.Response> {
    return Client(`product/${productId}/purchase-impact?${QueryUtil.stringify(query)}`);
  }

  static getOneProductList (
    id: string,
    isDetailed = false,
  ): Promise<ProductEndpoint.GetProductById.Response> {
    const query = QueryUtil.stringify({ isDetailed });
    return Client(`product/${id}?${query}`);
  }

  static delete (id: string): Promise<ProductEndpoint.ProductList.Response> {
    return Client(`product/${id}/`, { method: 'DELETE' });
  }

  static productListData (query: ProductEndpoint.ProductList.Query):
    Promise<ProductEndpoint.ProductList.Response> {
    return Client(`product?${QueryUtil.stringify(query)}`);
  }

  static getProductList (
    query: ProductEndpoint.ProductList.Query,
  ): Promise<ProductEndpoint.ProductList.Response> {
    const queryString = QueryUtil.stringify(query);
    return Client(`product-list?${queryString}`, { method: 'GET' });
  }

  static get (
    id: string,
    isDetailed?: boolean,
  ): Promise<ProductEndpoint.GetProductById.Response> {
    if (isDetailed) {
      const query = QueryUtil.stringify({ isDetailed });
      return Client(`product/${id}?${query}`);
    } else {
      return Client(`product/${id}`);
    }
  }
}
